import { SvgIconProps } from "../types";

 /**
 * SvgIcon get three props from SvgIconProps. Inside src create link after svg/ and input here name of image. 
 */

export const SvgIcon = ({ src, width, height }: SvgIconProps) => (
  <img src={`./img/svg/${src}`} alt={src} width={width} height={height} />
);
